import React, { useRef, useEffect } from "react";
import Image from "components/image";
import Button from "components/button";
import { formatTitle } from "helpers/format-title";

const Timeline = (props) => {
	const { data, button, image, title } = props.data;
	const elementRefs = Array.from({ length: data.length }, () => useRef(null));

	useEffect(() => {
		const viewportHeight = window.innerHeight;
		const handleScroll = () => {
			elementRefs.forEach((ref) => {
				const element = ref.current;
				if (!element) return;

				const elementTop = element.getBoundingClientRect().top;

				if (elementTop < viewportHeight / 2) element.classList.add("active_step");
				else element.classList.remove("active_step");
			});
		};

		window.addEventListener("scroll", handleScroll);

		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, [elementRefs]);

	return (
		<div className="my-10 flex flex-col justify-center px-5 w-full lg:w-4/5 m-auto hd-screen-max-width">
			<h2 className="text-center md:my-[4.188rem] mb-8 mt-0">{formatTitle(title)}</h2>
			<div className="flex flex-row">
				<div className="w-1/2 hidden lg:block">
					<Image className="mr-20 h-3/4 w-3/4" image={image} />
				</div>
				<div className="w-full lg:w-1/2 lg:mt-8">
					{data?.map((d, index) => (
						<div key={index} id={`step-${index}`} ref={elementRefs[index]} className="step">
							<div className="animate-line" />
							<div className="animate-image">
								<Image width={30} image={d?.icon} />
							</div>
							<div className="flex flex-col lg:ml-8">
								<h2 className="font-medium mb-3 text-h4">{formatTitle(d?.title)}</h2>
								<p className="text-secondary text-sm md:text-base leading-[1.55]">{d?.subtitle}</p>
							</div>
						</div>
					))}
					<div className="m-auto" id="ctaBtn">
						<Button data={button} className="mt-5 w-fit m-auto lg:-ml-24 px-14 py-3.5" />
					</div>
				</div>
			</div>
		</div>
	);
};

export default Timeline;
